export function wrapLinkWithAnchor(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g; // Регулярний вираз для пошуку URL

  return text
    ? text?.replace(urlRegex, (url) => `<a href="${url}" target="_blank">${url}</a>`)
    : '';
}
